type Params = {
  debugKey?: string;
} & Record<string, any>;

export function debugLog(params: Params): void {
  params.debugKey &&
    console.log({
      ...params,
    });
}
